module.exports = __webpack_public_path__ + "img/BatResidentielV.d35d3dc7.png";